import { createSlice } from '@reduxjs/toolkit';
import { isDefined } from '@sgme/fp';

import { userApi } from '@/api/user/index.ts';
import { defaultUserPreferenceData, type UserPreferencesState } from '@/store/userPreferences/state.ts';

export const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState: defaultUserPreferenceData,
  reducers: {},
  selectors: {
    getUserPreferences: (state) => state,
  },
  extraReducers(builder) {
    builder.addMatcher(userApi.endpoints.currentUser.matchFulfilled, (state, action) => {
      if (action.payload.userPreferences) {
        return { ...state, ...(action.payload.userPreferences as Partial<UserPreferencesState>) };
      }
      return state;
    });

    builder.addMatcher(userApi.endpoints.updateUserPreferences.matchFulfilled, (state, action) => {
      const userPreferencesData = action.meta.arg.originalArgs;
      if (isDefined(userPreferencesData)) {
        return userPreferencesData;
      }

      return state;
    });
  },
});

export const { getUserPreferences } = userPreferencesSlice.selectors;
